var exports = {
  "z8": "footerContent__lHVmgN",
  "N_": "Link__4aGngn",
  "bx": "Link_1__n4jCnU",
};

module.exports = exports;
